import * as React from "react";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import PersonAdd from "@mui/icons-material/PersonAdd";
import Settings from "@mui/icons-material/Settings";
import Logout from "./../../CustomFunction/User/logout";
import parseJwt from "./../../CustomFunction/parseJWT";
import styles from "./../../assets/jss/psstyle/component/headerStyle";
import HourglassEmptyRoundedIcon from "@mui/icons-material/HourglassEmptyRounded";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import {
  drawerWidth,
  transition,
  boxShadow,
  defaultFont,
  primaryColor,
  primaryBoxShadow,
  infoColor,
  successColor,
  warningColor,
  dangerColor,
  whiteColor,
  blackColor,
  hexToRgb,
  minHeight,
  appbarHeight,
} from "./../../assets/jss/psstyle/psacount";
import { Button, Grid } from "@mui/material";

export default function AccountMenu(props) {
  const { categoryReport, onMenuClick } = props;
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const [anchorElnew, setAnchorElnew] = React.useState(null);
  const opennew = Boolean(anchorElnew);

  const [TimeOutText, setTimeOutText] = React.useState(false);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClicknew = (event) => {
    setAnchorElnew(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClosenew = () => {
    setAnchorElnew(null);
  };

  const Chkclink = (e) => {
    // ปิด menu ก่อน navigate
    handleClosenew();
    // ปิด toolbar (SwipeableDrawer) ถ้ามี callback
    if (onMenuClick) {
      onMenuClick();
    }
    // ใช้ navigate แทน window.location.href เพื่อป้องกัน page reload
    navigate("/" + e);
  };
  const urlPast = window.location.hostname;

  const logout = (e) => {
    Logout();
    // Navigate to login page using React Router instead of window.location
    navigate("/login");
  };

  const coundown = () => {
    //console.log("xxxxxxxxxxxxxxxxxx", localStorage.getItem('Token'));
    if (localStorage.getItem("Token")) {
      // setInterval(() => {
      var TimeOut = parseJwt(localStorage.getItem("Token")).exp * 1000;
      console.log("TimeOut", TimeOut);

      var x = setInterval(function () {
        // Get today's date and time
        var now = new Date().getTime();
        // Find the distance between now and the count down date
        var distance = TimeOut - now;

        // Time calculations for days, hours, minutes and seconds
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // Display the result in the element with id="demo"
        // document.getElementById("demo").innerHTML = days + "d " + hours + "h " + minutes + "m " + seconds + "s ";
        setTimeOutText(hours + "h " + minutes + "m " + seconds + "s ");
        // If the count down is finished, write some text
        if (distance < 0) {
          clearInterval(x);
          // Use navigate instead of window.location.href
          navigate("/logout");
        }
      }, 1000);
    }
  };

  React.useEffect(() => {
    coundown();
    console.log("categoryReport", categoryReport);
  }, []);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          textAlign: "center",
          minHeight: minHeight,
        }}
      >
        <Button
          variant="text"
          onClick={() => Chkclink("home")}
          sx={{
            minWidth: 100,
            ...styles.text,
            ...styles.menuitem,
          }}
        >
          หน้าหลัก
        </Button>
        {/* <Tooltip title={<Typography sx={{ fontFamily: defaultFont }}>รายงานต่างๆ</Typography>} >
                    <IconButton
                        onClick={handleClick}
                        size="small"
                        sx={{ ml: 2, ...styles.text, ...styles.menuitem }}
                        aria-controls={open ? 'account-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                    >
                        รายงาน
                       
                    </IconButton>
                </Tooltip> */}

        <Tooltip
          title={
            <Typography sx={{ fontFamily: defaultFont }}>
              รายงานต่างๆ
            </Typography>
          }
        >
          <IconButton
            onClick={handleClicknew}
            size="small"
            sx={{ ml: 2, ...styles.text, ...styles.menuitem }}
            aria-controls={open ? "account-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
          >
            {" "}
            รายงาน
          </IconButton>
        </Tooltip>

        {localStorage.getItem("Permissiongroup") !== null ? (
          localStorage.getItem("Permissiongroup").toLowerCase() === "admin" ? (
            <Button
              variant="text"
              sx={{ minWidth: 100, ...styles.text, ...styles.menuitem }}
              onClick={() => Chkclink("manage")}
            >
              {" "}
              ผู้ดูแล{" "}
            </Button>
          ) : (
            ""
          )
        ) : (
          ""
        )}
        <Button
          variant="text"
          onClick={() => logout()}
          sx={{ minWidth: 100, ...styles.text, ...styles.menuitem }}
        >
          ออกจากระบบ
        </Button>
      </Box>

      <Menu
        anchorEl={anchorElnew}
        id="menunew"
        open={opennew}
        onClose={handleClosenew}
        onClick={handleClosenew}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: -1,
              right: 14,
              width: 10,
              height: 5,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {/* <MenuItem key={"PDIReport"} onClick={() => Chkclink("PDIReport")} sx={{ paddingTop: 0, paddingBottom: -1, }} >
                    ข้อมูลส่ง HONDA
                </MenuItem>
                <MenuItem key={"YamahaReport"} onClick={() => Chkclink("YamahaReport")} sx={{ paddingTop: 0, paddingBottom: -1, }} >
                    ข้อมูลส่ง YAMAHA
                </MenuItem> */}

        {typeof categoryReport !== "undefined"
          ? categoryReport.length > 0
            ? Object.keys(categoryReport).map(function (key) {
                return (
                  <MenuItem
                    key={categoryReport[key].nameTH}
                    sx={{ mt: 0, mb: 0, pt: 0, pb: 0, ...styles.text }}
                    onClick={() => Chkclink(`report/${categoryReport[key].id}`)}
                  >
                    {categoryReport[key].nameTH}
                  </MenuItem>
                );
              })
            : ""
          : ""}

        {urlPast === "psmt.pspl.co.th" || urlPast === 'localhost'? (
          <>
            <MenuItem
              key={"PDIReport"}
              onClick={() => Chkclink("PDIReport")}
              sx={{ paddingTop: 0, paddingBottom: -1, ...styles.text }}
            >
              ข้อมูลส่ง HONDA
            </MenuItem>
            <MenuItem
              key={"YamahaReport"}
              onClick={() => Chkclink("YamahaReport")}
              sx={{ paddingTop: 0, paddingBottom: -1, ...styles.text }}
            >
              ข้อมูลส่ง YAMAHA
            </MenuItem>
          </>
        ) : (
          ""
        )}
      </Menu>
    </>
  );
}
AccountMenu.propTypes = {
  categoryReport: PropTypes.array,
  onMenuClick: PropTypes.func,
};
